"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _axios = _interopRequireDefault(require("axios"));
var _intlDesignUi = require("@tencent/intl-design-ui");
var _CommonInput = _interopRequireDefault(require("./components/CommonInput"));
var _PhoneInput = _interopRequireDefault(require("./components/PhoneInput"));
var _MultipleChoiceInput = _interopRequireDefault(require("./components/MultipleChoiceInput"));
var _TimeMultipleChoiceInput = _interopRequireDefault(require("./components/TimeMultipleChoiceInput"));
var _UploadInput = _interopRequireDefault(require("./components/UploadInput"));
var _reportUtil = require("../../utils/reportUtil");
var _valid = require("../../utils/valid");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
require("./Form.scss");
var _sessionStorage = _interopRequireDefault(require("../../utils/sessionStorage"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
_axios.default.defaults.withCredentials = true;
_axios.default.defaults.crossDomain = true;
_axios.default.defaults.headers.post['Content-Type'] = 'application/json';
const FORM_ITEM_TYPE = {
  TEXT: 'TEXT',
  TIME: 'TIME',
  TIME_YEAR: 'TIME_YEAR',
  TIME_MONTH: 'TIME_MONTH',
  TIME_DAY: 'TIME_DAY',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  REGION: 'REGION',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  UPLOAD: 'UPLOAD'
};
const validLenLimit = (value, num) => !value || value.length <= num;
const validField = (formItemList = [], lang = 'en') => {
  return formItemList.map(item => {
    const required = item.required,
      type = item.type,
      placeholder = item.placeholder,
      lanConfig = item.lanConfig;
    let label = item.label,
      multipleChoice = item.multipleChoice;
    let name = label;
    // 取多ioc配置里面多语言
    if (lanConfig) {
      const langObj = lanConfig[lang] || {};
      label = langObj.label || '';
      name = langObj.label || '';
      // 特殊类型没有多语言
      if (type !== FORM_ITEM_TYPE.PHONE) {
        if (type === FORM_ITEM_TYPE.REGION) {
          multipleChoice = langObj.regionChoice || multipleChoice;
        } else {
          multipleChoice = langObj.multipleChoice || multipleChoice;
        }
      }
    }
    let validateMethod;
    switch (type) {
      case FORM_ITEM_TYPE.EMAIL:
        validateMethod = _valid.vaildEmail;
        break;
      case FORM_ITEM_TYPE.TIME:
        validateMethod = val => {
          let year;
          let month;
          let day;
          val.replace(/(\d+)?-(\d+)?-(\d+)?/g, ($, $1, $2, $3) => {
            year = $1;
            month = $2;
            day = $3;
          });
          return year && month && day;
        };
        break;
      case FORM_ITEM_TYPE.PHONE:
        validateMethod = val => {
          let area;
          let phone;
          val.replace(/(\d+)?-(\d+)?/g, ($, $1, $2) => {
            area = $1;
            phone = $2;
          });
          const validPhone = (code, num) => {
            if (!code || !num) {
              return false;
            }
            if (code === '86' && /^1[0-9]{10}$/.test(num)) {
              return true;
            }
            if (code !== '86' && /^[0-9]{5,11}$/.test(num)) {
              return true;
            }
            return false;
          };
          return validPhone(area, phone);
        };
        break;
      default:
        break;
    }
    return [name, label, validateMethod, 1000, type, required, multipleChoice, placeholder || label];
  });
};
const QuestionInput = ({
  name,
  required,
  field,
  onChange,
  onBlur,
  onFocus,
  data,
  type,
  multipleChoice,
  placeholder,
  uploadTxtObj,
  langObj,
  lang
}) => /*#__PURE__*/React.createElement(React.Fragment, null, type === FORM_ITEM_TYPE.PHONE && /*#__PURE__*/React.createElement(_PhoneInput.default, {
  name,
  required,
  field,
  onChange,
  onBlur,
  onFocus,
  data,
  multipleChoice,
  langObj,
  lang
}), (type === FORM_ITEM_TYPE.EMAIL || type === FORM_ITEM_TYPE.TEXT) && /*#__PURE__*/React.createElement(_CommonInput.default, {
  name,
  required,
  field,
  onChange,
  onBlur,
  onFocus,
  data,
  placeholder
}), (type === FORM_ITEM_TYPE.MULTIPLE_CHOICE || type === FORM_ITEM_TYPE.REGION) && /*#__PURE__*/React.createElement(_MultipleChoiceInput.default, {
  name,
  required,
  field,
  onChange,
  onBlur,
  onFocus,
  data,
  multipleChoice,
  placeholder
}), type === FORM_ITEM_TYPE.TIME && /*#__PURE__*/React.createElement(_TimeMultipleChoiceInput.default, {
  name,
  required,
  field,
  onChange,
  onBlur,
  onFocus,
  data,
  langObj
}), type === FORM_ITEM_TYPE.UPLOAD && /*#__PURE__*/React.createElement(_UploadInput.default, {
  name,
  required,
  field,
  onChange,
  data,
  placeholder,
  uploadTxtObj
}));
const TableForm = ({
  psData,
  agreementList,
  getDataFuncRef,
  inputData,
  setInputData,
  lang = 'en',
  uploadTxtObj,
  langObj,
  btnText,
  commodity,
  submit
}) => {
  const _React$useState = React.useState([]),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    fieldList = _React$useState2[0],
    setFieldList = _React$useState2[1];
  const _React$useState3 = React.useState([]),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    agrCmptList = _React$useState4[0],
    setAgrCmptList = _React$useState4[1];
  const _React$useState5 = React.useState([]),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    agrStatusList = _React$useState6[0],
    setAgrStatusList = _React$useState6[1];
  const _langObj$validRequied = langObj.validRequiedTxt,
    validRequiedTxt = _langObj$validRequied === void 0 ? 'It cannot be left empty.' : _langObj$validRequied,
    _langObj$validLenLimi = langObj.validLenLimitTxt,
    validLenLimitTxt = _langObj$validLenLimi === void 0 ? 'Word limit exceeded' : _langObj$validLenLimi,
    _langObj$validateMeth = langObj.validateMethodTxt,
    validateMethodTxt = _langObj$validateMeth === void 0 ? 'Incorrect format. Please check and enter again.' : _langObj$validateMeth;
  React.useEffect(() => {
    const arr = validField(psData, lang).map(item => {
      if (item[0]) {
        return {
          name: item[0],
          field: item[1],
          type: item[4],
          required: item[5],
          multipleChoice: item[6] || [],
          checker: param => {
            let value = param;
            // 过滤掉值为空或者phone类型默认值为-
            if (item[4] === FORM_ITEM_TYPE.PHONE && value === '-') {
              value = '';
            }
            if (item[5] && !(0, _valid.validRequied)(value)) {
              return [false, validRequiedTxt];
            }
            if (!validLenLimit(value, item[3] || 0)) {
              return [false, validLenLimitTxt];
            }
            if ((0, _valid.validRequied)(value) && item[2] && !item[2](param)) {
              return [false, validateMethodTxt];
            }
            return [true];
          },
          placeholder: item[7]
        };
      }
      return null;
    }).filter(item => !!item);
    setFieldList(arr);
  }, [psData, langObj]);
  React.useEffect(() => {
    const arr = agreementList.map((item, index) => {
      if (item.agreement !== '<p></p>') {
        var _agrStatusList$index, _agrStatusList$index2;
        return _objectSpread(_objectSpread({}, item), {}, {
          isRead: ((_agrStatusList$index = agrStatusList[index]) === null || _agrStatusList$index === void 0 ? void 0 : _agrStatusList$index.isRead) || false,
          isReadError: ((_agrStatusList$index2 = agrStatusList[index]) === null || _agrStatusList$index2 === void 0 ? void 0 : _agrStatusList$index2.isReadError) || false
        });
      }
    });
    setAgrCmptList(arr);
  }, [agreementList, agrStatusList]);
  React.useEffect(() => {
    getDataFuncRef.current = () => {
      // 解析表单
      let isError = false;
      const formData = {};
      fieldList.map(item => {
        inputData[item.field] = inputData[item.field] || {};
        const _item$checker = item.checker(inputData[item.field].value),
          _item$checker2 = (0, _slicedToArray2.default)(_item$checker, 2),
          isRight = _item$checker2[0],
          errMsg = _item$checker2[1];
        inputData[item.field].isError = !isRight;
        inputData[item.field].errMsg = errMsg;
        isError = isError || !isRight;
        formData[item.field] = `${inputData[item.field].value || ''}`;
      });
      setInputData(_objectSpread({}, inputData));
      // 解析协议
      const agrStatusList1 = agrCmptList.map(item => {
        if (!item.isRead) {
          item.isReadError = true;
          isError = true;
        }
        return {
          isRead: item.isRead,
          isReadError: item.isReadError
        };
      });
      setAgrStatusList(agrStatusList1);
      return !isError && formData || false;
    };
  }, [fieldList, inputData, agrCmptList]);
  return /*#__PURE__*/React.createElement("div", {
    className: "intl-formtable"
  }, fieldList.length > 0 && fieldList.map((item, index) => /*#__PURE__*/React.createElement(QuestionInput, Object.assign({
    key: index
  }, item, {
    uploadTxtObj: uploadTxtObj,
    langObj: langObj,
    lang: lang,
    data: inputData[item.field] || {},
    onChange: value => {
      const newData = _objectSpread({}, inputData);
      newData[item.field] = inputData[item.field] || {};
      newData[item.field].value = value;
      newData[item.field].isError = false;
      newData[item.field].errMsg = '';
      setInputData(newData);
    },
    onFocus: () => {
      const newData = _objectSpread({}, inputData);
      newData[item.field] = inputData[item.field] || {};
      newData[item.field].isError = false;
      newData[item.field].errMsg = '';
      setInputData(newData);
    },
    onBlur: () => {
      const newData = _objectSpread({}, inputData);
      newData[item.field] = inputData[item.field] || {};
      const _item$checker3 = item.checker(newData[item.field].value),
        _item$checker4 = (0, _slicedToArray2.default)(_item$checker3, 2),
        isRight = _item$checker4[0],
        errMsg = _item$checker4[1];
      newData[item.field].isError = !isRight;
      newData[item.field].errMsg = errMsg;
      setInputData(newData);
    }
  }))), agrCmptList.map((item, index) => /*#__PURE__*/React.createElement(TermCheckbox, {
    key: index,
    readError: item.isReadError || false,
    checked: item.isRead || false,
    content: item.agreement,
    validRequiedTxt: validRequiedTxt,
    onChange: event => {
      const checked = event.target.checked;
      const agreement = {
        isRead: checked,
        isReadError: !checked
      };
      agrStatusList.splice(index, 1, agreement);
      setAgrStatusList([...agrStatusList]);
    }
  })), fieldList.length > 0 && /*#__PURE__*/React.createElement(SubmitBtn, {
    btnText: btnText,
    commodity: commodity,
    submit: submit
  }));
};
function TermCheckbox(props) {
  const readError = props.readError,
    checked = props.checked,
    validRequiedTxt = props.validRequiedTxt;
  const _React$useState7 = React.useState(checked),
    _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
    isRead = _React$useState8[0],
    setIsRead = _React$useState8[1];
  const _React$useState9 = React.useState(readError),
    _React$useState0 = (0, _slicedToArray2.default)(_React$useState9, 2),
    isReadError = _React$useState0[0],
    setIsReadError = _React$useState0[1];
  React.useEffect(() => {
    setIsRead(checked);
    setIsReadError(readError);
  }, [checked, readError]);
  // 过滤富文本为空时候的默认返回情况
  const isConnect = props.content && props.content !== '<p></p>';
  if (!isConnect) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "event-form-box intl-terms-checkbox-field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rno-form rno-form-vertical"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rno-form-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rno-form-controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)('rno-radio-group', {
      'rno-form-status-error': isReadError
    })
  }, /*#__PURE__*/React.createElement("label", {
    className: "rno-checkbox-block"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "rno-checkbox",
    name: "isOk",
    checked: isRead,
    onChange: props.onChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "rno-checkbox-label",
    dangerouslySetInnerHTML: {
      __html: props.content
    }
  })), isReadError && /*#__PURE__*/React.createElement("div", {
    className: "rno-form-message"
  }, validRequiedTxt))))));
}
function SubmitBtn(props) {
  const commodity = props.commodity,
    submit = props.submit,
    btnText = props.btnText;
  return /*#__PURE__*/React.createElement("div", {
    className: "report-form-row-s"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "report-form-row-btn",
    "report-event": "click_formTable_submit",
    "report-ext1": commodity,
    onClick: submit
  }, btnText));
}
function submitQuestionAnswerForm(getDataFuncRef, psData, resultCommodityObject, lang, loginTxtObj) {
  const formData = getDataFuncRef.current();
  if (!formData) {
    return;
  }
  // 组装数据
  const resultFormData = psData.map(item => {
    const lanConfig = item.lanConfig;
    let label = item.label;
    if (lanConfig && lanConfig[lang]) {
      label = lanConfig[lang].label || '';
    }
    const value = formData[label] || '';
    return {
      type: item.type,
      label,
      value
    };
  });
  console.log('submitQuestionAnswerForm--', resultFormData, formData);
  doSubmitReq(_objectSpread({
    formData: resultFormData
  }, resultCommodityObject), loginTxtObj);
}
function doSubmitReq(parmas, loginTxtObj = {}) {
  const _ref = loginTxtObj,
    title = _ref.title,
    content = _ref.content,
    btnTxt = _ref.btnTxt;
  (0, _axios.default)({
    method: 'get',
    url: '/render/api/configsolution/getUserInfo'
  }).then(({
    data
  }) => {
    var _data$data;
    if ((data === null || data === void 0 ? void 0 : data.code) === 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.uin) {
      window.submitForm(parmas, true);
    } else {
      _sessionStorage.default.set('ftable', JSON.stringify(parmas));
      _intlDesignUi.Modal.alert({
        size: 'small',
        icon: 'info-circle',
        title,
        content,
        btnOkMsg: btnTxt,
        onOk() {
          window.location.href = `${location.origin}/login?s_url=${encodeURIComponent(location.href)}`;
        }
      });
    }
  });
}
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos,
  lang = 'en'
}) {
  const componentData = data;
  const _React$useState1 = React.useState({}),
    _React$useState10 = (0, _slicedToArray2.default)(_React$useState1, 2),
    inputData = _React$useState10[0],
    setInputData = _React$useState10[1];
  const getDataFuncRef = React.useRef();
  if (componentData) {
    const _data$commodityObject = data.commodityObject,
      commodityObject = _data$commodityObject === void 0 ? '{}' : _data$commodityObject,
      _data$gradientColor = data.gradientColor,
      gradientColor = _data$gradientColor === void 0 ? '' : _data$gradientColor,
      _data$color = data.color,
      color = _data$color === void 0 ? '' : _data$color,
      _data$title = data.title,
      title = _data$title === void 0 ? '' : _data$title,
      _data$desc = data.desc,
      desc = _data$desc === void 0 ? '' : _data$desc,
      _data$porintId = data.porintId,
      porintId = _data$porintId === void 0 ? '' : _data$porintId,
      _data$tableData = data.tableData,
      tableData = _data$tableData === void 0 ? [] : _data$tableData,
      btnText = data.btnText,
      paddingTopNum = data.paddingTopNum,
      paddingBottomNum = data.paddingBottomNum,
      _data$agreementList = data.agreementList,
      agreementList = _data$agreementList === void 0 ? [] : _data$agreementList,
      _data$uploadTxtObj = data.uploadTxtObj,
      uploadTxtObj = _data$uploadTxtObj === void 0 ? {} : _data$uploadTxtObj,
      _data$langObj = data.langObj,
      langObj = _data$langObj === void 0 ? {} : _data$langObj,
      _data$loginTxtObj = data.loginTxtObj,
      loginTxtObj = _data$loginTxtObj === void 0 ? {} : _data$loginTxtObj;
    const agreementListFilter = agreementList.filter(item => item.agreement !== '<p></p>');
    const resultCommodityObject = (0, _formatCommodityData.formatFormCommodityData)(commodityObject);
    const _React$useState11 = React.useState(tableData),
      _React$useState12 = (0, _slicedToArray2.default)(_React$useState11, 2),
      psData = _React$useState12[0],
      setPSData = _React$useState12[1];
    const bgStyle = {};
    if (color) {
      bgStyle.background = color;
    }
    const paddingStyle = (0, _componentUtils.doComponentsStyleEvent)({
      paddingTopNum,
      paddingBottomNum
    }); // 处理组件背景色
    paddingStyle.minWidth = 'unset';
    if (gradientColor) {
      bgStyle.background = '';
      bgStyle.backgroundImage = gradientColor;
    }
    React.useEffect(() => {
      // mock数据
      // const { data: result, code } = mockData;
      // if (code === 0 && result.customizeQust) {
      //   const customizeQust = JSON.parse(result.customizeQust);
      //   setPSData(customizeQust);
      // }
      // 编辑器不请求接口
      if (location.hostname.endsWith('.woa.com')) {
        return;
      }
      if (!tableData.length) {
        (0, _axios.default)({
          method: 'post',
          url: '/render/api/configsolution/queryFormInfo',
          data: {
            ecId: resultCommodityObject.commodity
          }
        }).then(({
          data
        }) => {
          const _data$data2 = data.data,
            result = _data$data2 === void 0 ? {} : _data$data2,
            code = data.code;
          if (code === 0 && result.customizeQust) {
            const customizeQust = JSON.parse(result.customizeQust);
            setPSData(customizeQust);
          }
        }).catch(() => {});
      }
    }, []);
    React.useEffect(() => {
      // 取session数据
      const formTableLogin = _sessionStorage.default.get('ftable');
      if (formTableLogin) {
        _sessionStorage.default.remove('ftable');
        doSubmitReq(JSON.parse(formTableLogin), loginTxtObj);
      }
      return () => _sessionStorage.default.remove('ftable');
    }, []);
    const submit = () => {
      submitQuestionAnswerForm(getDataFuncRef, psData, resultCommodityObject, lang, loginTxtObj);
    };
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId
    }, (0, _reportUtil.reportShow)(['show_formTable', componentKey, porintId]), {
      style: bgStyle
    }), /*#__PURE__*/React.createElement(_intlDesignUi.Section, {
      title: title,
      desc: desc,
      style: paddingStyle
    }, /*#__PURE__*/React.createElement(TableForm, {
      psData,
      agreementList: agreementListFilter,
      getDataFuncRef,
      inputData,
      setInputData,
      lang,
      uploadTxtObj,
      langObj,
      btnText,
      commodity: resultCommodityObject.commodity || '',
      submit
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}